import {
    PurchasingContainer,
    PurchasingRegister,
} from '@Purchasing/Data/DataSource/Container'
import { PurchasingStage } from '@Purchasing/Domain/Model/PurchaseProcess'
import { useEffect, useState } from 'react'

export const usePurchasingStages = () => {
    const useCase = PurchasingContainer.get(
        PurchasingRegister.UseCaseGetPurchasingStages
    )
    const [stages, setStages] = useState<PurchasingStage[]>([])
    const [loading, setLoading] = useState<boolean>(false)

    useEffect(() => {
        ;(async () => {
            setLoading(true)
            try {
                const result = await useCase.execute()
                setStages(result)
            } catch (e) {
                console.error(e)
            }
            setLoading(false)
        })()
    }, [useCase])

    return { stages, loading }
}
